<template>
	<v-col cols="5" class="flex-none mx-auto">
		<div class="inventory-form">
			<div class="form-radio">
				<label>Drop Ship</label>
				<v-radio-group v-model="itemData.dropShip" row hide-details="auto">
					<v-radio label="Yes" :disabled="!canManageInventory" :value="true"></v-radio>
					<v-radio label="No" :disabled="!canManageInventory" :value="false"></v-radio>
				</v-radio-group>
			</div>

			<div v-if="itemData.dropShip == true" class="form-radio">
				<label>Packing List</label>
				<v-radio-group
					:disabled="!canManageInventory"
					v-model="itemData.packingList"
					row
					hide-details="auto"
				>
					<v-radio label="Yes" :value="true"></v-radio>
					<v-radio label="No" :value="false"></v-radio>
				</v-radio-group>
			</div>

			<div class="form-radio">
				<label>Stock Items</label>
				<v-radio-group v-model="itemData.stockItems" row hide-details="auto">
					<v-radio :disabled="!canManageInventory" label="Yes" :value="true"></v-radio>
					<v-radio :disabled="!canManageInventory" label="No" :value="false"></v-radio>
				</v-radio-group>
			</div>

			<div v-if="itemData.stockItems == true" class="form-radio">
				<label>Infinite Inventory</label>
				<v-radio-group v-model="itemData.infiniteInventory" row hide-details="auto">
					<v-radio :disabled="!canManageInventory" label="Yes" :value="true"></v-radio>
					<v-radio :disabled="!canManageInventory" label="No" :value="false"></v-radio>
				</v-radio-group>
			</div>

			<div class="form-input" v-else>
				<label>Processing</label>
				<v-select
					v-model="itemData.processTypeId"
					:items="processes"
					item-text="name"
					item-value="processTypeId"
					dense
					outlined
					hide-details="auto"
					clearable
					:disabled="!canManageInventory"
				></v-select>
			</div>
		</div>
	</v-col>
</template>

<script>
import gql from "graphql-tag";
export default {
	name: "InventoryItemInformationView",
	props: {
		canManageInventory: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			itemData: {
				dropShip: null,
				packingList: null,
				stockItems: null,
				infiniteInventory: null,
				processTypeId: null,
			},
			processes: [{ name: "No Processing", processTypeId: 1 }],
		};
	},
	apollo: {
		processes: {
			query() {
				return gql`
					query ListProcessTypes {
						processTypes(take: 50, order: { sequence: ASC }) {
							items {
								processTypeId: id
								name
								sequence
							}
							pageInfo {
								hasNextPage
								hasPreviousPage
							}
						}
					}
				`;
			},
			update(data) {
				return data.processTypes.items;
			},
		},
	},
	computed: {
		storeItem() {
			return this.$store.getters.inventoryItem;
		},
	},
	watch: {
		// Re-adopt the store object whenever the parent view's async fetch
		// replaces it — children mount before the parent's mounted() completes,
		// so a one-shot read here can capture a stale tree and orphan edits.
		storeItem: {
			immediate: true,
			handler(item) {
				this.itemData = item;
			},
		},
	},
	beforeDestroy() {
		//push current item data to state
		if (this.itemData.stockItems) this.itemData.processTypeId = null;
		this.$store.dispatch("updateInventoryItem", this.itemData);

		//let parent component know data has been updated in state
		this.$emit("updated");
	},
};
</script>

<style lang="scss" scoped>
.inventory {
	&-form {
		.form-input {
			.v-select {
				width: 100%;
			}
		}
	}
}
</style>
